<template>
    <v-card-title class="headline primary white--text">
        <div class="title">
            {{ label }}
            <em class="mt-2" v-if="sublabel">{{ sublabel }}</em>
        </div>
        <v-spacer />
        <v-btn icon dark :disabled="disabled" @click="close">
            <v-icon>close</v-icon>
        </v-btn>
    </v-card-title>
</template>

<script>
export default {
    name: 'card-title',
    props: {
        label: { type: String },
        sublabel: { type: String },
        disabled: { type: Boolean }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="stylus" scoped>
.title {
    font-size: 50%;

    em {
        display: block;
        font-size: 80%;
    }
}
</style>
